import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Grow from "@mui/material/Grow";
import { Alert, Stack, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { removeAlert } from "../../redux/Reducers/appSlice";

const AUTO_HIDE_MS = 4000;

const FloatingAlerts = () => {
  const dispatch = useDispatch();
  const { alerts } = useSelector((state) => state.app);

  return (
    <Stack
      spacing={1.5}
      sx={{
        position: "fixed",
        top: 16,
        right: 16,
        zIndex: (theme) => theme.zIndex.snackbar + 1,
        pointerEvents: "none",
        alignItems: "flex-end",
        maxWidth: { xs: "calc(100vw - 32px)", sm: 420 },
      }}
    >
      {alerts.map((alert) => (
        <Snackbar
          key={alert.key}
          open
          onClose={(_event, reason) => {
            if (reason === "clickaway") return;
            dispatch(removeAlert({ key: alert.key }));
          }}
          autoHideDuration={AUTO_HIDE_MS}
          TransitionComponent={Grow}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{
            position: "static",
            transform: "none",
            pointerEvents: "auto",
          }}
        >
          <Alert
            severity={alert.severity}
            variant="filled"
            elevation={4}
            onClose={() => dispatch(removeAlert({ key: alert.key }))}
            sx={{
              width: "100%",
              alignItems: "center",
              boxShadow: "0 8px 24px rgba(15,23,42,0.15)",
            }}
          >
            <Typography variant="body2" component="span">
              {alert.message}
            </Typography>
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
};

export default FloatingAlerts;
